import { apiClient } from '@/shared/api';

import type {
  MaterializeResult,
  ProductSetPage,
  ProductSetRequest,
  ProductSetResponse,
} from '../model/types';

const BASE = '/api/v1/catalog/promo/product-sets';

export interface ListProductSetsParams {
  page?: number;
  size?: number;
}

export const listProductSets = async (
  params: ListProductSetsParams = {},
): Promise<ProductSetPage> => (await apiClient.get<ProductSetPage>(BASE, { params })).data;

export const createProductSet = async (body: ProductSetRequest): Promise<ProductSetResponse> =>
  (await apiClient.post<ProductSetResponse>(BASE, body)).data;

export const getProductSet = async (productSetId: string): Promise<ProductSetResponse> =>
  (await apiClient.get<ProductSetResponse>(`${BASE}/${productSetId}`)).data;

export const updateProductSet = async (
  productSetId: string,
  body: ProductSetRequest,
): Promise<ProductSetResponse> =>
  (await apiClient.put<ProductSetResponse>(`${BASE}/${productSetId}`, body)).data;

export const materializeProductSet = async (productSetId: string): Promise<MaterializeResult> =>
  (await apiClient.post<MaterializeResult>(`${BASE}/${productSetId}/materialize`)).data;
